

// frontend/src/api/guestApi.js
// Thin wrapper for guest/user profile endpoints
import { apiClient } from './apiClient';

// NOTE: we prefer querystring parameters over a separate `params` object
// to avoid 400s (per project convention).

export const guestApi = {
  // GET /api/user/:uid
  async getByUid(uid) {
    if (!uid) throw new Error('uid is required');
    const res = await apiClient.get(`/user/${encodeURIComponent(uid)}`);
    return res.data; // Full UserProfile document
  },

  // POST /api/user/register
  async register({ userUid, email, propertyId, profile = {}, stayPreferences = {} }) {
    const res = await apiClient.post('/user/register', {
      userUid,
      email,
      propertyId,
      profile,
      stayPreferences,
    });
    return res.data;
  },

  // POST /api/user/login
  async login({ userUid, email, fullName, propertyId }) {
    const res = await apiClient.post('/user/login', {
      userUid,
      email,
      fullName,
      propertyId,
    });
    return res.data;
  },

  // POST /api/user/update-profile
  async updateProfile({ userUid, propertyId, profile }) {
    const res = await apiClient.post('/user/update-profile', {
      userUid,
      propertyId,
      profile,
    });
    return res.data;
  },

  // PUT /api/user/update-preferences
  async updatePreferences({ userUid, stayPreferences }) {
    const res = await apiClient.put('/user/update-preferences', {
      userUid,
      stayPreferences,
    });
    return res.data;
  },

  // GET /api/user/search?query=...&propertyId=...&page=..&limit=..
  async search({ query = '', propertyId, page = 1, limit = 50 }) {
    const q = new URLSearchParams({ query, propertyId, page: String(page), limit: String(limit) }).toString();
    const res = await apiClient.get(`/user/search?${q}`);
    return res.data; // { users, total }
  },

  // GET /api/user/new-count?propertyId=...
  async newCount(propertyId) {
    const q = new URLSearchParams({ propertyId }).toString();
    const res = await apiClient.get(`/user/new-count?${q}`);
    return res.data; // { success, count }
  },

  // PUT /api/user/mark-seen?propertyId=...
  async markSeen(propertyId) {
    const q = new URLSearchParams({ propertyId }).toString();
    const res = await apiClient.put(`/user/mark-seen?${q}`);
    return res.data; // { success, updatedCount }
  },
};

export default guestApi;